import angular from 'angular';
import moment from 'moment';

angular.module('cloudX').directive('cxTimespanDatetime', function() {
  return {
    restrict: 'A',
    require: '^ngModel',
    link: function(scope, el, attrs, ngModel) {
      if (!ngModel) return;
      var timeRegex = /^(0?[0-9]|1[0-9]|2[0-3]):([0-5]?[0-9])(?::([0-5]?[0-9]))?$/;
      var timeFormatter = function(value) {
        if (value === null || typeof value === 'undefined') return null;
        var m = value.match(timeRegex);
        if (!m) return undefined;

        return moment()
          .startOf('day')
          .set({
            hour: parseInt(m[1]) || 0,
            minute: parseInt(m[2]) || 0,
            second: parseInt(m[3]) || 0,
          })
          .toDate();
      };
      ngModel.$formatters.push(timeFormatter);
      ngModel.$parsers.push(function(value) {
        if (!value) return value;
        if (typeof value === 'string' && value.match(timeRegex)) return value;
        if (value instanceof Date) return moment(value).format('HH:mm:ss');
        return value;
      });
      ngModel.$validators.time = function(modelValue) {
        if (!modelValue) return true;
        var m = modelValue.match(timeRegex);
        if (!m) return false;
        //Validate seconds if available
        if (m[3] && parseInt(m[3]) >= 60) return false;
        //Validate minutes
        return parseInt(m[2]) < 60;
      };
    },
  };
});
